import Vue from 'vue'
import App from './App.vue'
import LightBootstrap from './light-bootstrap-main'
import './registerServiceWorker'
import VueSession from 'vue-session'
import router from '@/routes/routes.js'
import store from '@/store/store.js'
import config from "@/config"

import { createPinia, PiniaVuePlugin } from 'pinia'
import piniaPersistedstate from 'pinia-plugin-persistedstate'

import { ValidationProvider, ValidationObserver, extend } from 'vee-validate/dist/vee-validate.full.esm';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret, faBuilding, faImages, faEnvelope, faPhone, faSpinner, faSignOut, faDollarSign, faQuestionCircle, faTimes, faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import Vue2Editor from "vue2-editor";
import "vue-easytable/libs/theme-default/index.css";
import VueEasytable from "vue-easytable";

import * as VueGoogleMaps from 'vue2-google-maps'

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

library.add(faUserSecret, faBuilding, faImages, faEnvelope, faPhone, faSpinner, faSignOut, faDollarSign, faQuestionCircle, faTimes, faCheck)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(LightBootstrap)
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

const options = {
  persist: true
}

Vue.use(VueSession, options)

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

Vue.use(Toast);
Vue.use(Vue2Editor);
Vue.use(VueEasytable);
Vue.use(VueGoogleMaps, {
  load: {
    key: config.CD_GOOGLE_MAPS_API_KEY,
    libraries: 'places',
  }
});

Vue.component('v-select', vSelect)

Vue.use(PiniaVuePlugin)

const pinia = createPinia()
pinia.use(piniaPersistedstate)

extend('cien', {
  message: 'El porcentaje tiene que ser del 100%',
  validate: value => value == 100,
});

new Vue({
  pinia,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
